<template>
  <div style="padding: 20px 0">
    <Form ref="form" :model="form" :rules="ruleValidate" label-position="left" :label-width="80">
      <template v-if="form.user_type==1">
        <FormItem label="用户名" prop="username">
          <Input v-model="form.username" :disabled="userInfoMemberId==1?true:false" placeholder="请输入用户名"></Input>
        </FormItem>
        <FormItem label="密码" prop="password">
          <Input type="password" style="width: calc(100% - 300px)" v-model="form.password" placeholder="请输入密码"></Input>
          <span style="color: red;padding-left: 8px">*不填默认是原来密码，新添是最新密码</span>
        </FormItem>
      </template>
      <template v-else>
        <FormItem label="姓名" prop="name">
          <Input v-model="form.name" placeholder="请输入姓名"></Input>
        </FormItem>
        <FormItem label="手机号" prop="tel">
          <Input v-model="form.tel" placeholder="请输入手机号"></Input>
        </FormItem>
        <FormItem v-if="form.user_type==3" label="工作单位">
          <Input v-model="form.work" placeholder="请输入工作单位"></Input>
        </FormItem>
        <FormItem v-if="form.user_type==3" label="职称">
          <Input v-model="form.professional" placeholder="请输入职称"></Input>
        </FormItem>
        <FormItem v-if="form.user_type==3" label="所属院系">
          <Input v-model="form.academy" placeholder="请输入所属院系"></Input>
        </FormItem>
      </template>
      <FormItem>
        <Button type="primary" :loading="loading" @click="handleSubmit('form')">保存数据</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {

  props: {
    condition: {
      type: [Boolean, Number, String, Array],
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        //全部
        library_id: localStorage.getItem('libId'),
        user_type: localStorage.getItem('user_type'),
        status: 1,//状态 1正常 2禁用
        //管理员
        username: '',//用户名
        password: null,//密码
        // 编辑、专家
        name: '',//姓名
        tel: '',//手机号
        //专家
        work: '',//工作单位
        professional: '',//职称
        academy: '',//所属院系
      },
      ruleValidate: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        tel: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {type: 'string', min: 11, message: '小于11位', trigger: 'blur'},
          {type: 'string', max: 11, message: '大于11位', trigger: 'blur'},
          {
            pattern: '^1(3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])[0-9]{8}$',
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],

        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
        ],
      },
      userInfoMemberId:localStorage.getItem('userInfoMemberId')
    }
  },
  methods: {

    /*****************************************************************
     * 表单验证
     * @param   {name}             要验证的表单名称
     *****************************************************************/
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          this.editSubmit()
        } else {
          this.loading = false
          this.$Message.error('请核对输入内容!');
        }
      })
    },
    /*****************************************************************
     *
     * 修改数据
     *
     *****************************************************************/
    editSubmit() {
      this.$set(this.form, 'id', localStorage.getItem('userInfoMemberId'))
      this.$httpsencrypt.post('api/contributeweb/v3/users/edit', this.form).then(val => {
        this.loading = false;
        this.$Message.success('修改成功,请重新登录!');
        setTimeout(() => {
          this.$router.push({path: '/login', query: {lib: this.$route.query.lib,alis:this.$route.query.alis}})
          this.$clearLocalStorageExceptActivePages()
          sessionStorage.clear()
          this.$store.state.tabList = '[]'
          this.$store.state.userInfo = ''
        }, 1000)
      }).catch(err => {
        this.loading = false;
      })
    },

    /*****************************************************************
     *
     * 单条查询数据
     *
     *****************************************************************/
    selData() {
      let cond = {
        id: localStorage.getItem('userInfoMemberId'),
        library_id: localStorage.getItem('libId'),
        user_type: localStorage.getItem('user_type'),
      }
      this.$httpsencrypt.post('api/contributeweb/v3/users/info', cond).then(val => {
        this.form.status = val.data.status
        this.form.name = val.data.name
        this.form.tel = val.data.tel
        this.form.work = val.data.work
        this.form.professional = val.data.professional
        this.form.academy = val.data.academy

        this.form.username = val.data.username
        this.form.status = val.data.status
      }).catch(err => {
      })
    },


  },
  mounted() {
    this.selData()
  }
};
</script>
